module.exports = __webpack_public_path__ + "img/mask.615ea363.png";